
document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('contactForm');
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        sendContact();
    });
});

const URL = 'https://api.web3forms.com/submit';

function sendContact() {
    const form = document.getElementById('contactForm');
    const resultsDiv = document.querySelector('.contact-results');
    resultsDiv.innerText = 'Nous envoyons votre message...';
    resultsDiv.classList.remove('success', 'error');
    
    // for each in form.querySelectorAll('input'), setAttribute('disabled', 'disabled')
    const formData = new FormData(form);
    // form.querySelectorAll('input').forEach((input) => { input.setAttribute('disabled', 'disabled'); });
    
    fetch(form.getAttribute('action'), {
        method: 'POST',
        body: formData
    }).then((response) => {
        if (response.status === 200) {
            console.log('Success:', response);
            resultsDiv.classList.add('success');
            resultsDiv.innerText = 'Merci, nous acheminons votre message, et ne manquerons pas de vous contacter sous 48h (jours ouvrés) !';
            form.querySelectorAll('input').forEach((input) => { input.removeAttribute('disabled'); });
            form.reset();
        } else {
            resultsDiv.classList.add('error');
            resultsDiv.innerHTML = 'Une erreur est survenue et nous nous en excusons.. ! <br />Si cela venait à se reproduire, n \'hésitez pas à nous contacter par <a href="tel:+33951101001">téléphone</a> ou par <a href="mailto:contact@a-c.fr">mail</a>.';
        }
    }).catch((error) => {
        console.error('Error:', error);
        resultsDiv.classList.add('error');
        resultsDiv.innerHTML = 'Une erreur est survenue et nous nous en excusons.. ! <br />Si cela venait à se reproduire, n \'hésitez pas à nous contacter par <a href="tel:+33951101001">téléphone</a> ou par <a href="mailto:contact@a-c.fr">mail</a>.';
    });
}
